import React from "react";
import { useTranslation } from "react-i18next";

const ContactDirectoryHeader = () => {
	const { t } = useTranslation();

	return (
		<div>
			<div className="header-box container-fluid">
				<div className="landing-header">
					<img className="header-icon" />
					{" "}
					{t("contactDirectory.title")}
				</div>
			</div>
		</div>
	)
}

export default ContactDirectoryHeader;
